(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cms-shared"] && !Shopify.designMode) return;
  try {
    if (!window.__cmsRevealInit) {
  window.__cmsRevealInit = true;
  var cmsRevealIo = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        cmsRevealIo.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.cms-rv').forEach(function (el) {
    cmsRevealIo.observe(el);
  });
}
  } catch(e) { console.error(e); }
})();

})();
